import { render, staticRenderFns } from "./mock-receipt-card.vue?vue&type=template&id=c7c05ffe&scoped=true&"
import script from "./mock-receipt-card.vue?vue&type=script&lang=js&"
export * from "./mock-receipt-card.vue?vue&type=script&lang=js&"
import style0 from "./mock-receipt-card.vue?vue&type=style&index=0&id=c7c05ffe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7c05ffe",
  null
  
)

export default component.exports